//聊天账号配置信息缓存，如一键留资
//{account_xxx:{dy_one_click_phone_card_list:[]}}
const accountCfgStore = {}

function getAccountKey(accountId) {
    return `account_${accountId}`
}

export function getAccountCfg(accountId) {
    if (!accountId) {
        return {}
    }
    let key = getAccountKey(accountId)
    let res = accountCfgStore[key]
    if (!res) {
        return {}
    }
    return res
}

export function getAccountCfgByKey(accountId, cfgKey) {
    if (!cfgKey) {
        return
    }
    if (!accountId) {
        return
    }

    let key = getAccountKey(accountId)
    let res = accountCfgStore[key]

    if (!res) {
        return
    }
    return res[cfgKey]
}

export function setAccountCfg(accountId, config = {}) {
    if (!accountId) {
        return
    }
    if (!config) {
        return
    }
    let key = getAccountKey(accountId)
    let oldCfg = getAccountCfg(key)
    accountCfgStore[key] = Object.assign(oldCfg, config)
}
